import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { useReviewsContext } from '../../ReviewsContext/ReviewsContext.js';
import { loadReviewDisplay } from '../../ReviewsContext/actions.js';

const REVIEW_DISPLAY_ID = 'pr-review-display';
const ReviewDisplay = ({ productId , variantId  })=>{
    const { enabled , dispatch  } = useReviewsContext();
    React.useEffect(()=>{
        const observer = new MutationObserver(()=>{
            if (document.querySelector('#pr-review-snapshot')) {
                const mainDiv = document.querySelector(`#${REVIEW_DISPLAY_ID}`);
                const svgIcons = mainDiv && [
                    ...mainDiv.getElementsByTagName('svg')
                ];
                svgIcons === null || svgIcons === void 0 ? void 0 : svgIcons.forEach((svg)=>{
                    svg.setAttribute('aria-hidden', 'true');
                });
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }, []);
    React.useEffect(()=>{
        if (enabled && productId) {
            dispatch(loadReviewDisplay({
                id: REVIEW_DISPLAY_ID,
                productId,
                variantId
            }));
        }
    }, [
        dispatch,
        enabled,
        productId,
        variantId
    ]);
    if (!enabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "review-display",
        "data-t": "review-display"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("div", {
        id: REVIEW_DISPLAY_ID
    }, /*#__PURE__*/ React.createElement(Loader, null))));
};
var ReviewDisplay$1 = ReviewDisplay;

export { REVIEW_DISPLAY_ID, ReviewDisplay$1 as default };
//# sourceMappingURL=ReviewDisplay.js.map
